module.exports = __webpack_public_path__ + "static/media/biet_logo.54dd5c29.png";